<template>
  <generic-modal :title="$t('request log')" ref="generic_modal">
    <div class="activity-log">
      <div v-if="log.length === 0" class="has-text-centered py-6">
        <span class="icon is-large has-text-grey-light">
          <i class="fa fa-2x fa-clock"></i>
        </span>
        <p class="has-text-grey">{{ $t("no activities yet") }}</p>
      </div>

      <div v-else class="timeline-container">
        <div
          v-for="(activity, index) in sortedLog"
          :key="index"
          class="timeline-item"
          :class="{ 'is-last': index === sortedLog.length - 1 }"
        >
          <!-- Timeline marker -->
          <div class="timeline-marker">
            <div
              class="timeline-icon"
              :class="getActivityClass(activity.message)"
            >
              <i class="fa" :class="getActivityIcon(activity.message)"></i>
            </div>
          </div>

          <!-- Timeline content -->
          <div class="timeline-content">
            <div class="timeline-card">
              <div class="timeline-header">
                <span class="activity-message">{{
                  getFormattedMessage(activity.message)
                }}</span>
                <span
                  class="activity-badge"
                  :class="getActivityClass(activity.message)"
                >
                  {{ getActivityType(activity.message) }}
                </span>
              </div>
              <div class="timeline-time">
                <span class="icon is-small">
                  <i class="fa fa-clock"></i>
                </span>
                <span>{{ formatTimestamp(activity.timestamp) }}</span>
                <span class="has-text-grey-light">
                  ({{ getRelativeTime(activity.timestamp) }})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PATRÓN CORRECTO: usar v-slot:footer -->
    <template v-slot:footer>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";
import moment from "moment";

export default {
  name: "RequestLogModal",
  components: { GenericModal },
  data() {
    return {
      log: [],
      error: "",
    };
  },
  computed: {
    sortedLog() {
      return [...this.log].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );
    },
  },
  methods: {
    getActivityClass(message) {
      if (message.includes("created")) return "is-success";
      if (message.includes("RENAP")) return "is-info";
      if (message.includes("step changed")) return "is-primary";
      if (message.includes("completed")) return "is-success";
      if (message.includes("error") || message.includes("failed"))
        return "is-danger";
      return "is-grey";
    },
    getActivityIcon(message) {
      if (message.includes("created")) return "fa-plus-circle";
      if (message.includes("RENAP")) return "fa-id-card";
      if (message.includes("step changed")) return "fa-arrow-right";
      if (message.includes("completed")) return "fa-check-circle";
      if (message.includes("error") || message.includes("failed"))
        return "fa-exclamation-triangle";
      return "fa-circle";
    },
    getActivityType(message) {
      if (message.includes("created")) return "Creación";
      if (message.includes("RENAP")) return "Validación";
      if (message.includes("step changed")) return "Navegación";
      if (message.includes("completed")) return "Completado";
      if (message.includes("error") || message.includes("failed"))
        return "Error";
      return "Actividad";
    },
    getFormattedMessage(message) {
      // Capitalizar primera letra y mejorar formato
      return message.charAt(0).toUpperCase() + message.slice(1);
    },
    formatTimestamp(timestamp) {
      return moment(timestamp).format("DD/MM/YYYY HH:mm:ss");
    },
    getRelativeTime(timestamp) {
      moment.locale("es");
      return moment(timestamp).fromNow();
    },
    show(uuid) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      get("/account-request/transference/log", { uuid: uuid })
        .then((response) => {
          v.log = response;
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        client_dpi: "",
        client_email: "",
        client_phone: "",
        status: "pending",
        admin_notes: "",
        settings: null,
      };
      this.error = "";
      this.entity_uuid = "";
      this.is_clone = false;
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 700px;
  max-width: 95vw;
}

.activity-log {
  max-height: 600px;
  overflow-y: auto;
  padding: 1rem;
}

/* Timeline Styles */
.timeline-container {
  position: relative;
  padding-left: 2rem;
}

.timeline-container::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, #3273dc 0%, #e9ecef 50%, #3273dc 100%);
  border-radius: 1px;
}

.timeline-item {
  position: relative;
  margin-bottom: 1.5rem;
  padding-left: 2rem;
}

.timeline-item.is-last {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -2rem;
  top: 0.5rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 3px solid white;
  position: relative;
  z-index: 1;
}

.timeline-icon.is-success {
  background: linear-gradient(135deg, #48c78e 0%, #40b883 100%);
}

.timeline-icon.is-info {
  background: linear-gradient(135deg, #3298dc 0%, #2366d1 100%);
}

.timeline-icon.is-primary {
  background: linear-gradient(135deg, #3273dc 0%, #2366d1 100%);
}

.timeline-icon.is-danger {
  background: linear-gradient(135deg, #f14668 0%, #cc1f3d 100%);
}

.timeline-icon.is-grey {
  background: linear-gradient(135deg, #b5b5b5 0%, #999999 100%);
}

.timeline-content {
  flex: 1;
}

.timeline-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
}

.timeline-card::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 1rem;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #e9ecef;
}

.timeline-card::after {
  content: "";
  position: absolute;
  left: -7px;
  top: 1rem;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid white;
}

.timeline-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.activity-message {
  font-weight: 600;
  color: #363636;
  line-height: 1.4;
  flex: 1;
  margin-right: 1rem;
}

.activity-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.activity-badge.is-success {
  background: rgba(72, 199, 142, 0.1);
  color: #40b883;
  border: 1px solid rgba(72, 199, 142, 0.2);
}

.activity-badge.is-info {
  background: rgba(50, 152, 220, 0.1);
  color: #2366d1;
  border: 1px solid rgba(50, 152, 220, 0.2);
}

.activity-badge.is-primary {
  background: rgba(50, 115, 220, 0.1);
  color: #2366d1;
  border: 1px solid rgba(50, 115, 220, 0.2);
}

.activity-badge.is-danger {
  background: rgba(241, 70, 104, 0.1);
  color: #cc1f3d;
  border: 1px solid rgba(241, 70, 104, 0.2);
}

.activity-badge.is-grey {
  background: rgba(181, 181, 181, 0.1);
  color: #999999;
  border: 1px solid rgba(181, 181, 181, 0.2);
}

.timeline-time {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #666;
}

.timeline-time .icon {
  color: #999;
}

/* Scrollbar personalizado */
.activity-log::-webkit-scrollbar {
  width: 6px;
}

.activity-log::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.activity-log::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.activity-log::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 768px) {
  .modal-card {
    width: 100%;
    margin: 0;
  }

  .activity-log {
    padding: 0.5rem;
    max-height: 70vh;
  }

  .timeline-item {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  .timeline-marker {
    left: -1.5rem;
    width: 2rem;
    height: 2rem;
  }

  .timeline-icon {
    width: 2rem;
    height: 2rem;
    font-size: 0.75rem;
  }

  .timeline-card {
    padding: 0.75rem;
  }

  .timeline-header {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .activity-message {
    margin-right: 0;
    margin-bottom: 0.25rem;
  }
}
</style>
